var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortCutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "header-icon m-2",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n        }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.5,193.2H21.4c-8.1,0-14.6-6.6-14.6-14.6V21.5c0-8.1,6.6-14.6,14.6-14.6h57.3c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1H21.4c-4.6,0-8.4,3.8-8.4,8.4v157c0,4.6,3.8,8.4,8.4,8.4h157c4.6,0,8.4-3.8,8.4-8.4v-58c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1v58c0,8.1-6.6,14.6-14.6,14.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.6,111.7v56H32.3V32.3h57.4c-2-2.2-4.1-4.3-6.4-6.1l.6.5c-.2-.2-.4-.4-.6-.6H30.3c-2.3,0-4.2,1.9-4.2,4.2v139.3c0,2.3,1.9,4.2,4.2,4.2h139.3c2.3,0,4.2-1.9,4.2-4.2v-52.9c-2.2-1.6-4.3-3.2-6.2-5.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tSz6jl.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.9,160.9c-21.8,0-45.9-16.1-54.2-36.5-9.4-23-4.9-47.8,12.8-70,4-5.1,8.8-9.5,13.5-13.8,1.4-1.3,2.9-2.6,4.3-4l-22.8-22.5c-1.2-1.2-1.6-3.1-1-4.7.7-1.6,2.2-2.7,4-2.7l92,.3c6.1,3,6.7,8.4,6.7,12.2,0,21.5,0,67.3,0,83.3,0,2.2-1.3,4.2-3.3,5-2.1.9-4.4.4-6-1.2l-27.1-27.5c-5.7,3.8-22,16.6-30,40.6-2.8,8.6-.8,15.9,6.3,22.5,1.8,1.7,4,3,6.4,4.4,1.7,1,3.3,2,4.9,3.1,1.4,1.1,4.5,4,3.4,7.1-1.3,3.6-6.4,4.2-8.5,4.2-.4,0-.8,0-1.2,0ZM99.2,13.1l23.9,23.6-2.2,2.2c-2.2,2.2-4.4,4.2-6.7,6.3-4.7,4.3-9.1,8.4-12.8,13.1-16.4,20.6-20.5,42.6-11.9,63.7,7.6,18.5,29.8,33.2,49.4,32.6.5,0,1,0,1.5-.2-1.3-.9-2.8-1.8-4.3-2.7-2.5-1.5-5.1-3.1-7.4-5.2-8.9-8.3-11.6-18.1-8-29,10.5-31.5,33.9-44.8,34.9-45.3l2.1-1.1,29.2,29.6c0-17.5,0-60.7,0-81.4,0-3.7-1-5.3-2.6-6.2h-85.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortCutImg);
export default __webpack_public_path__ + "static/media/short-cut-img.dca53a6188f04451629ddd8579430dfc.svg";
export { ForwardRef as ReactComponent };